module.exports = __webpack_public_path__ + "img/FR18789.48071648.png";